import React from "react";
import Nav from "./Nav";
import ToDoBox from "./ToDoBox";
import Greet from "./Greet";

function App() {
  return (
    <div>
      <Nav />
      <Greet />
      <ToDoBox />
    </div>
  );
}

export default App;
